module.exports = __webpack_public_path__ + "static/img/feature2.062ffcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature2.png
// module id = fnNz
// module chunks = 36